:host {
  display: inline-block;
  width: 100%;
}

.product-tile {
  position: relative;
  font-family: var(--primary-font);
  width: 100%;
  height: auto;
  box-sizing: border-box;
  max-width: 320px;
  margin: 0 auto;
  border-bottom: 1px solid var(--color-silver);
  color: var(--color-nero);

  a {
    color: var(--color-nero);
    text-decoration: none;
  }

  &.open {
    @include breakpointMin('lg') {
      position: relative;
      @include layerIndex('fifth');
      border-bottom: 1px solid transparent;
      box-shadow: rgb(99 99 99 / 20%) 0px -2px 8px 0px;

      .bottom-left {
        display: none;
      }
    }
  }

  // top
  .top {
    position: relative;
    @include layerIndex('first');

    .top-left {
      position: absolute;
      top: 5px;
      left: 5px;
      @include layerIndex('second');

      img {
        width: 23px;
        height: auto;
      }

      ::slotted(*) {
        width: 19px;
        height: 19px;

        @include breakpointMin('md') {
          width: 23px;
          height: 23px;
        }
      }

      &.hide {
        display: none;
      }
    }

    .top-right {
      position: absolute;
      top: 5px;
      right: 5px;
      @include layerIndex('second');
    }

    .bottom-left {
      position: absolute;
      bottom: 5px;
      left: 5px;
      @include layerIndex('second');
    }

    .bottom-right {
      position: absolute;
      bottom: 5px;
      right: 5px;
      @include layerIndex('second');
    }

    .img {
      display: flex;
      justify-content: center;
      align-items: center;
      aspect-ratio: 1;

      img {
        width: 100%;
        max-width: 100%;
        height: auto;
      }
    }
  }

  // bottom
  .bottom {
    padding: 5px;
    padding-bottom: 5px;
    background: var(--color-white);

    & > * {
      min-height: 20px;
      margin-top: 6px;

      @include breakpointMin('md') {
        min-height: 40px;
      }
    }

    .sub-header {
      font-size: 10px;
      font-weight: var(--font-weight-semibold);
      display: flex;
      flex-flow: row nowrap;
      justify-content: space-between;
      align-items: baseline;
      height: 30px;
      margin-bottom: 5px;

      @include breakpointMin('md') {
        height: 40px;
      }

      &.brandElement {
        .price {
          display: flex;
          flex-flow: row wrap;
          width: auto;
          max-width: 62%;
          justify-content: flex-start;
          align-items: center;
          column-gap: 5px;

          & > span {
            margin-right: 2px;
            height: 15px;

            @include breakpointMin('md') {
              margin-right: 5px;
              height: auto;
            }
          }
        }

        ::slotted([slot='brand']) {
          display: flex;
          align-items: flex-end;
          width: auto;
        }
      }

      .price {
        display: flex;
        column-gap: 5px;
      }
    }

    .header {
      font-size: 12px;
      font-weight: var(--font-weight-semibold);
      display: block;
      height: 32px;
      margin-bottom: 10px;

      @include breakpointMin('md') {
        font-size: 16px;
        height: 40px;
      }

      ::slotted([slot='title']) {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
      }
    }

    .variant {
      display: flex;
      justify-content: end;
      flex-direction: column;
      height: 44px;
      margin-bottom: 5px;

      @include breakpointMin('md') {
        height: 56px;
      }

      .label {
        font-size: 10px;

        @include breakpointMin('md') {
          font-size: 14px;
        }

        ::slotted([slot='variant-label']) {
          font-size: 10px;

          @include breakpointMin('md') {
            font-size: 14px;
          }
        }
      }

      .color-picker {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }

      &.tall {
        height: 61px;

        @include breakpointMin('md') {
          height: 73px;
        }
      }
    }

    .hover-desktop {
      @include breakpointMin('md') {
        display: none;
        position: absolute;
        width: calc(100% - 10px);
        margin: -5px;
        padding: 5px;
        box-shadow: rgb(99 99 99 / 20%) 0px 6px 8px 0px;
        bottom: -102px;
      }
    }

    .variant-switcher {
      display: none;
      height: 25px;

      @include breakpointMin('md') {
        display: grid;
        grid-template-rows: 1fr;
        grid-template-columns: 1fr 1fr;
        gap: 10px;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 5px;
      }

      ::slotted([slot='variant-switcher']) {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        width: 100%;
      }

      ::slotted(*:last-of-type) {
        margin-right: 0;
      }
    }

    .delivery {
      height: 35px;
      padding-top: 10px;

      @include breakpointMin('md') {
        height: 25px;
        padding-top: 4px;
        margin-bottom: 5px;
      }
    }

    .delivery,
    .accessible {
      lilu-p {
        font-size: 12px;
      }
    }

    .accessible {
      display: none;
      height: 25px;
      cursor: pointer;

      @include breakpointMin('md') {
        display: block;
        height: 35px;
      }
    }
  }

  &.open {
    .hover-desktop {
      @include breakpointMin('md') {
        display: block;
        padding-bottom: 5px;
        background-color: white;
      }
    }
  }
}

// adapted from https://uxdesign.cc/using-css-design-a-simple-skeleton-loader-57d884cd3547

.skeleton {
  &.product-tile {
    margin: 12px 0 8px 0;
    border-bottom: none;
  }

  div {
    border-radius: 10px;
  }

  .skeleton-loader {
    opacity: 0.5;

    div {
      border-radius: 10px;
    }

    &.image {
      aspect-ratio: 1 / 1;
      height: auto;
      margin-left: 0px;
      margin-bottom: 8px;
    }

    &.price {
      width: 95%;
      height: 15px;
      margin-bottom: 30px;
    }

    &.title {
      height: 35px;
      width: 70%;
      margin-bottom: 33px;
    }

    &.colors {
      width: 40%;
      margin-bottom: 3px;
    }

    width: 100%;
    height: 25px;
    display: block;
    margin: 0 0 0 10px;
    background: linear-gradient(to right, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.5) 50%, rgba(255, 255, 255, 0) 80%), var(--color-silver);
    background-repeat: repeat-y;
    background-size: 250px 500px;
    background-position: 0 0;
    animation: shine 2s infinite;
  }
  @keyframes shine {
    from {
      background-position:
        -500% 0,
        /* move highlight to right */ 0 0;
    }
    to {
      background-position:
        500% 0,
        /* move highlight to right */ 0 0;
    }
  }
}
